import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack} from 'views/components';
import {Logout as LogoutIcon} from 'views/icons';
import {Translate, translate, Map} from 'views/module';

import BuildCareview from './BuildCareview';
import TimelineCard from './TimelineCard';
import moment from 'moment';

const ShiftClockedOut = (props) => {
  const {clockOut, caregiverData, answers} = props;

  const timeString = moment(clockOut.createdAt).format('LLL');

  const actualClockoutTimeFormatted = clockOut.data.actualClockoutTimeFormatted;
  const suggestedClockoutTimeFormatted = clockOut.data.suggestedClockoutTimeFormatted;

  // Format data if present
  const actualClockoutTime = actualClockoutTimeFormatted ? moment(actualClockoutTimeFormatted).format('h:mm A') : null;
  const suggestedClockoutTime = suggestedClockoutTimeFormatted ? moment(suggestedClockoutTimeFormatted).format('h:mm A') : null;
  const location = clockOut.data.location;
  const notes = clockOut.data.additionalNotes || translate('eventList.EventTimelineSection.ShiftClockedOut.NoNotes');

  return (
    <TimelineCard
      timeString={timeString}
      icon={LogoutIcon}
      iconColor="#1e8e3e"
      timeBg="#e0e0e0"
      title={
        <Typography variant="h5" fontWeight={700} fontSize={'22px'}>
          <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.Title' />
        </Typography>
      }
    >
      <Stack spacing={1}>
        <Typography fontWeight={700} color="text.secondary" fontSize={'16px'} textAlign="left">
          <Translate
            expression='eventList.EventTimelineSection.ShiftClockedOut.Description'
            substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
          />
        </Typography>

        {
          actualClockoutTimeFormatted && suggestedClockoutTimeFormatted &&
          (
            <Stack spacing={1}>
              {/* Clock out timings */}
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.ClockoutTime'/>
                </Typography>
                <Typography
                  fontWeight={700}
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  {actualClockoutTime}
                </Typography>
              </Stack>
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.EditedClockoutTime'/>
                </Typography>
                <Typography
                  fontWeight={700}
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  {suggestedClockoutTime}
                </Typography>
              </Stack>

              {/* Notes */}
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.Notes'/>
                </Typography>
                <Typography
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  {notes}
                </Typography>
              </Stack>

              {/* Location Data */}
              <Typography
                fontWeight={700}
                textAlign={'left'}
                fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
              >
                <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.Location'/>
              </Typography>
              {
                location ?
                <Map height={'200px'} width={'100%'} coordinates={[location.latitude, location.longitude]} /> :
                <Typography
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.NoLocation'/>
                </Typography>
              }

              {/* Careview Summary */}
              <Stack spacing={1} mt={2}>
                <Typography fontWeight={700} textAlign={'left'} fontSize={'18px'}>
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedOut.CareviewSummary'/>
                </Typography>
                <BuildCareview answers={answers} />
              </Stack>
            </Stack>
          )
        }
      </Stack>

    </TimelineCard>
  );
};

ShiftClockedOut.propTypes = {
  clockOut: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    data: PropTypes.shape({
      actualClockoutTimeFormatted: PropTypes.string,
      suggestedClockoutTimeFormatted: PropTypes.string,
      location: PropTypes.object,
      additionalNotes: PropTypes.string,
    }),
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  answers: PropTypes.object,
};

export default ShiftClockedOut;
